<template>
  <div class="contentBody">
    <div class="contentBody__section">
      <form class="authForm u-pd-r-1 u-pd-l-1"
      novalidate="true"
      :action="action"
      method="POST">
        <div class="authForm__body u-mg-b-4">
          <input type="hidden" name="_token" :value="token">
          <div
          class="alert"
          data-color="error"
          v-if="errorMessage"
          v-html="errorMessage"
          >
          {{ errorMessage }}
          </div>

          <form-input
          v-model="email"
          type="email"
          name="email"
          placeholder="半角英数字で入力してください"
          label="メールアドレス"
          :validation="{ rules: {
            required: true,
            nonRfcEmailCheck: true,
            email: false
            } }"
            ></form-input>
        </div>
        <div class="contentFooter">
          <button type="submit" class="btn shadow"
            data-color="brand"
            data-block="true"
            :desable="!isSend"
          >メール送信</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { PAYEE } from '@/CONSTS/'
import fetchAccountData from '@/utils/fetchAccountData'

export default {
  props: {
    action: String,
    method: String,
    token: String
  },
  data() {
    return {
      isSend : false,
    }
  },
  computed: {
    ...mapGetters([ 'isLoggedIn'])
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ReAuthForm.vue